import Typography from './Typography';
import { cn } from '../../utils/cn';

interface FormFieldProps {
  id: string;
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  type?: "text" | "email" | "tel";
  placeholder?: string;
  required?: boolean;
  inputMode?: "numeric" | "text";
  multiline?: boolean;
  rows?: number;
}

const FormField = ({
  id,
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  required = false,
  inputMode,
  multiline = false,
  rows = 4,
}: FormFieldProps) => {
  const baseClassName = cn(
    "w-full px-4 py-3 bg-white/[0.03] text-white placeholder-gray-600 rounded-md border text-sm transition-all duration-200",
    "focus:outline-none focus:border-white focus:ring-1 focus:ring-white",
    required ? "border-gray-700" : "border-gray-800/60"
  );

  return (
    <div>
      <Typography.Label htmlFor={id} className="block mb-2">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </Typography.Label>
      {multiline ? (
        <textarea
          id={id}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={cn(baseClassName, 'resize-none')}
          placeholder={placeholder}
          rows={rows}
          required={required}
        />
      ) : (
        <input
          id={id}
          type={type}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={baseClassName}
          placeholder={placeholder}
          required={required}
          inputMode={inputMode}
        />
      )}
    </div>
  );
};

export default FormField;
